import { EstimateMapController } from '../../../Summary/EstimateMap'
import { MarketMapContent } from './EstimateMarketMapContent'

export const MarketPurchaseMapConfig = {
  Controller: EstimateMapController,
  Content: () => <MarketMapContent type="purchase" />,
}

export const MarketRentalMapConfig = {
  Controller: EstimateMapController,
  Content: () => <MarketMapContent type="rental" />,
}
